module.exports = __webpack_public_path__ + "img/NVB_logo.00d23d7f.png";